// Copyright (c) 2021 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import Of06ScreenSubstitution from './Of06ScreenSubstitution';
import React from 'react';

function Of06ScreenSubstitutionPage () {

    return (
        <AuthenticatedPage className="atp-page atp-screen-substitution">
            <Of06ScreenSubstitution />
        </AuthenticatedPage>
    );

}
Of06ScreenSubstitutionPage.displayNAme = 'Of06ScreenSubstitutionPage';

export default Of06ScreenSubstitutionPage;
